import HolidayIdeas from './HolidayIdeas';

export default HolidayIdeas;
